export default "__VITE_ASSET__CFEJr$MX__"